export default __webpack_public_path__ + "static/media/cart.e885b276.svg";